import produce from "immer";
import { UPDATE_MOODBANNERHEIGHT } from "./moodBanner.actions";

const initialState: { moodBannerHeight: number; } = {
    moodBannerHeight: 0,
};

export default (moodBannerState = initialState, action: any): { moodBannerHeight: number; } => produce(moodBannerState, draft => {
    switch (action.type) {
        case UPDATE_MOODBANNERHEIGHT: {
            draft.moodBannerHeight = action.moodBannerHeight;
            break;
        }
    }
});
